export const CAREER_OFFER_BANNER_CAMPAIGN = 'salary_100k_test';
export const CAREER_OFFER_BANNER_PLACEMENT = 'auth_system_banner';
export const CAREER_OFFER_BANNER_UTM_SOURCE = 'algocode_auth';
export const CAREER_OFFER_BANNER_UTM_MEDIUM = 'banner';

export function isCareerOfferBannerArrival(searchParams: URLSearchParams) {
	return (
		searchParams.get('utm_source') === CAREER_OFFER_BANNER_UTM_SOURCE &&
		searchParams.get('utm_medium') === CAREER_OFFER_BANNER_UTM_MEDIUM &&
		searchParams.get('utm_campaign') === CAREER_OFFER_BANNER_CAMPAIGN &&
		Boolean(searchParams.get('utm_content'))
	);
}
